import React from "react";
import Home from "../Home";

function PortOwners(props) {
  return <div className="h1">PORT OWNERS: {props.name}</div>;
}

export default PortOwners;
